import { translate } from 'i18n/i18n'
import moment from 'moment-timezone'

export const getWeekRangeTitle = (weekOffset: number, timezone: string) => {
  const date = moment.tz(timezone).add(weekOffset, 'week')
  const start = translate.dates.format(date.clone().startOf('isoWeek'), 'MMM D')
  const end = translate.dates.format(date.clone().endOf('isoWeek'), 'MMM D')

  return `${start} - ${end}`
}
